// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import jobsForOrderTests$ from 'hfty-soil-jobs/src/selectors/jobsForOrderTests'
import { fields$ } from 'fc-assets'
import { currentUser$ } from 'hfty-users/src'

// Actions
import { createOrder } from '../actions'
import { updateUserBillingInfo } from 'hfty-orders'

// Operator
import orderTestsOperator from 'hfty-operator-order-tests'
import orderTestsOperation$ from '../selectors/orderTestsOperation'

// State -> Props
type Props = {
  currentUser: Object,
  jobsForOrderTests: Array<Object>,
  fields: Array<Object>,
}

function mapStateToProps (state: Object): Props {
  return {
    currentUser: currentUser$(state),
    jobsForOrderTests: jobsForOrderTests$(state),
    fields: fields$(state),
    operation: orderTestsOperation$(state),
  }
}

type MapDispatchToProps = {
  actions: {}
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      createOrder,
      updateUserBillingInfo,
      onChangeOperation: orderTestsOperator.actionCreators.updateOperation,
      onCancelOperation: orderTestsOperator.actionCreators.cancelOperation,
      onSubmitOperation: orderTestsOperator.actionCreators.submitOperation,
    }, dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
